import logger from './logger';

class LocalStorageUtils {
  static getItem(key, defaultValue = null) {
    try {
      const item = localStorage.getItem(key);
      if (item === null || item.trim() === '') {
        return defaultValue;
      }

      try {
        return JSON.parse(item);
      } catch (parseError) {
        // If JSON parsing fails, check if it's a plain string value for backwards compatibility
        if (typeof item === 'string' && item.trim() !== '') {
          return item;
        }
        logger.info('Failed to parse localStorage item as JSON, returning default value', {
          key,
          item,
          error: parseError.message,
          defaultValue,
        });
        return defaultValue;
      }
    } catch (error) {
      logger.error('Failed to access localStorage for reading', {
        key,
        operation: 'getItem',
        error: error.message,
        browserSupport: typeof Storage !== 'undefined',
      });
      return defaultValue;
    }
  }

  static setItem(key, value) {
    try {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
      return true;
    } catch (error) {
      logger.error('Failed to access localStorage for writing', {
        key,
        value,
        operation: 'setItem',
        error: error.message,
        browserSupport: typeof Storage !== 'undefined',
        storageQuotaExceeded: error.name === 'QuotaExceededError',
      });
      return false;
    }
  }
}

export default LocalStorageUtils;
